import {
    SET_HATCH_TIMER_VALUE,
    SET_HATCH_TIMER_VALUE_SUCCESS,
    SET_HATCH_TIMER_OUT,
    SET_HATCH_TIMER_OUT_SUCCESS,
    START_HATCH_GAME,
    START_HATCH_GAME_SUCCESS,
    ANSWER_HATCH_QUESTION,
    ANSWER_HATCH_QUESTION_SUCCESS,
    SHARE_CHALLENGE_CALENDAR,
    SHARE_CHALLENGE_CALENDAR_SUCCESS,
    SET_CALENDAR_EVENT_AUDIO_VALUE,
    SET_CALENDAR_EVENT_AUDIO_VALUE_SUCCESS,
    CLEAR_HATCHGAME_DATA,
    CLEAR_HATCHGAME_DATA_SUCCESS
} from './constants';

/**
 *
 * @returns {{type: string}}
 */
const claerHatchData = () => ( { type: CLEAR_HATCHGAME_DATA } );

/**
 *
 * @returns {{type: string}}
 */
const claerHatchDataSucess = () => ( { type: CLEAR_HATCHGAME_DATA_SUCCESS } );
/**
 *
 * @param val
 * @returns {{val: *, type: string}}
 */
const setTimerValue = ( val ) => ( { type: SET_HATCH_TIMER_VALUE, val } );
/**
 *
 * @param val
 * @returns {{val: *, type: string}}
 */
const setTimerValueSuccess = val => ( {
    type: SET_HATCH_TIMER_VALUE_SUCCESS,
    val
} );
/**
 *
 * @param val
 * @returns {{val: *, type: string}}
 */
const setTimerOut = ( val ) => ( { type: SET_HATCH_TIMER_OUT, val } );
/**
 *
 * @param val
 * @returns {{val: *, type: string}}
 */
const setTimerOutSuccess = val => ( {
    type: SET_HATCH_TIMER_OUT_SUCCESS,
    val
} );
/**
 *
 * @param hatchID
 * @param resolve
 * @returns {{hatchID: *, resolve: *, type: string}}
 */
const startHatchGame = ( hatchID, country, resolve ) => ( {
    type: START_HATCH_GAME,
    hatchID,
    country,
    resolve
} );
/**
 *
 * @param gameData
 * @returns {{gameData: *, type: string}}
 */
const startHatchGameSuccess = gameData => ( {
    type: START_HATCH_GAME_SUCCESS,
    gameData
} );
/**
 *
 * @param hatchID
 * @param gameID
 * @param answerObj
 * @returns {{gameID: *, hatchID: *, answerObj: *, type: string}}
 */
const answerHatchQuestion = ( hatchID, gameID, answerObj ) => ( {
    type: ANSWER_HATCH_QUESTION,
    hatchID,
    gameID,
    answerObj
} );
/**
 *
 * @param answerData
 * @returns {{answerData: *, type: string}}
 */
const answerHatchQuestionSuccess = answerData => ( {
    type: ANSWER_HATCH_QUESTION_SUCCESS,
    answerData
} );
/**
 *
 * @param id
 * @param hatchID
 * @param shareableType
 * @returns {{hatchID: *, shareableType: *, id: *, type: string}}
 */
const shareChallengeCalendar = ( id, hatchID, shareableType ) => ( {
    type: SHARE_CHALLENGE_CALENDAR,
    id,
    hatchID,
    shareableType
} );
/**
 *
 * @param challengeData
 * @returns {{challengeData: *, type: string}}
 */
const shareChallengeCalendarSuccess = ( challengeData ) => ( {
    type: SHARE_CHALLENGE_CALENDAR_SUCCESS,
    challengeData
} );
/**
 *
 * @param val
 * @returns {{val: *, type: string}}
 */
const setEventSound = ( val ) => ( { type: SET_CALENDAR_EVENT_AUDIO_VALUE, val } );
/**
 *
 * @param val
 * @returns {{val: *, type: string}}
 */
const setEventSoundSuccess = ( val ) => ( { type: SET_CALENDAR_EVENT_AUDIO_VALUE_SUCCESS, val } );

export {
    setTimerValue,
    setTimerValueSuccess,
    setTimerOut,
    setTimerOutSuccess,
    startHatchGame,
    startHatchGameSuccess,
    answerHatchQuestion,
    answerHatchQuestionSuccess,
    shareChallengeCalendar,
    shareChallengeCalendarSuccess,
    setEventSound,
    setEventSoundSuccess,
    claerHatchData,
    claerHatchDataSucess
};